"use client";
import { useEffect, useState } from "react";
import styles from "./page.module.scss";
import Image from "next/image";
import { authService } from "@/app/services/AuthService";
import { getPublicImagePath } from "@/app/utils/image";
import Locale from "@/app/locales";

export default function LoginPage() {
  const [error, setError] = useState(false);

  const handleLogin = async () => {
    try {
      await authService.login();
    } catch (err) {
      setError(true);
      const log = localStorage.getItem("SHOW_IM_LOG");
      if (log || process.env.NODE_ENV === "development") {
        console.log(err);
      }
    }
  };

  useEffect(() => {
    handleLogin();
  }, []);

  const imgUrl = error
    ? getPublicImagePath("im-error.svg")
    : getPublicImagePath("im-loading.svg");
  const desc = error ? Locale.error.loginError : Locale.error.loginLoading;

  return (
    <div className={styles.loginContentRoot}>
      <Image
        className={error ? styles.errorImg : styles.loadingImg}
        src={imgUrl}
        width={96}
        height={96}
        alt=""
      ></Image>
      <div className={styles.desc}>{desc}</div>
    </div>
  );
}
